var Checklist = /** @class */ (function () {
    function Checklist() {
    }
    return Checklist;
}());
export { Checklist };
